import React, { Component } from "react";
import { Form, Input, Select } from "antd";
import { FormComponentProps } from "antd/es/form";
import styles from "./style.module.scss";
import countries from "../../pages/settings/countryCode.json";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { MUTATE } from "../../utilities/network";

const countryNames: Array<string> = countries.map((e) => e.label);

const FormItemLayout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 17,
  },
};

interface CreateGroupFormModalProps extends FormComponentProps {
  visible: boolean;
  hideModal: () => void;
  onCreateGroupSuccess: () => Promise<void>;
}

@observer
class CreateGroupFormModal extends Component<CreateGroupFormModalProps> {
  @observable loading = false;

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className={styles.form}>
        <Form.Item label="Name" {...FormItemLayout}>
          {getFieldDecorator("name", {
            rules: [
              {
                required: true,
                message: "Please input group name.",
              },
              {
                max: 64,
                message: "Maximum length 64.",
              },
            ],
          })(<Input placeholder="Group name" />)}
        </Form.Item>

        <Form.Item label="Description" {...FormItemLayout}>
          {getFieldDecorator("description", {
            rules: [
              {
                required: true,
                message: "Please input the description of this group.",
              },
              {
                max: 512,
                message: "Maximum length 512.",
              },
            ],
          })(<Input placeholder="Group description" />)}
        </Form.Item>

        <Form.Item label="Country" {...FormItemLayout}>
          {this.props.form.getFieldDecorator("country", {
            rules: [
              {
                required: true,
                message: "Where is the headquarters?",
              },
            ],
          })(
            <Select placeholder="Country">
              {countryNames.map((country) => (
                <Select.Option value={country} key={country}>
                  {country}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Form>
    );
  }

  _onSubmit = () => {
    this.props.form.validateFields(async (error, values) => {
      if (!error) {
        this.loading = true;
        await MUTATE(CREATE_GROUP, values);
        await this.props.onCreateGroupSuccess();
        this.props.hideModal();
        this.loading = false;
      }
    });
  };
}

export default Form.create<CreateGroupFormModalProps>()(CreateGroupFormModal);

const CREATE_GROUP = `
mutation($country: String!, $description: String!, $name: String!) {
  createGroup(country: $country, description: $description, name: $name)
}`;
